export var VERSION = '1.3.3';
//# sourceMappingURL=version.js.map